<template>
  <div>
    <a-layout>
      <air-menu-left />
      <a-layout>
        <a-layout-header class="air__layout__header">
          <air-topbar />
        </a-layout-header>
        <a-layout-content>
          <div>
            <a-alert
              message="Scheduled Site Maintenance"
              description="TrueLife will be down for a scheduled maintenance on July 24 beginning at 14:00 EST for about 4 hours. Thanks for your patience."
              type="warning"
              show-icon
              v-if="false"
            />
            <router-view class="content-page" />
            <div :class="`bg-${isIndividual ? 'js-story-' : ''}footer`" />
          </div>
        </a-layout-content>
        <a-layout-footer>
          <air-footer />
        </a-layout-footer>
      </a-layout>
    </a-layout>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import AirTopbar from '@/components/layout/TopBar';
import AirMenuLeft from '@/components/layout/MenuLeft';
import AirFooter from '@/components/layout/Footer';

export default {
  name: 'AppLayout',
  computed: mapState(['settings']),
  components: {
    AirTopbar,
    AirMenuLeft,
    AirFooter,
  },
  mounted() {
    this.detectViewPort(true);
    window.addEventListener('resize', this.detectViewPortListener);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.detectViewPortListener);
  },
  methods: {
    detectViewPortListener: function () {
      this.detectViewPort(false);
    },
    setViewPort: function (isMobileView = false, isTabletView = false) {
      this.$store.commit('CHANGE_SETTING', {
        setting: 'isMobileView',
        value: isMobileView,
      });
      this.$store.commit('CHANGE_SETTING', {
        setting: 'isTabletView',
        value: isTabletView,
      });
    },
    detectViewPort: function (firstLoad = false) {
      const isMobile = this.settings['isMobileView'];
      const isTablet = this.settings['isTabletView'];
      const width = window.innerWidth;
      const state = {
        next: {
          mobile: width < 768,
          tablet: width < 992,
          desktop: !(width < 768) && !(width < 992),
        },
        prev: {
          mobile: isMobile,
          tablet: isTablet,
          desktop: !isMobile && !isTablet,
        },
      };
      // desktop
      // if (state.next.desktop && (state.next.desktop !== state.prev.desktop || firstLoad)) {
      //   this.setViewPort(false, false);
      // }
      // tablet & collapse menu
      if (state.next.tablet && !state.next.mobile && (state.next.tablet !== state.prev.tablet || firstLoad)) {
        this.setViewPort(false, true);
        this.$store.commit('CHANGE_SETTING', {
          setting: 'isMenuCollapsed',
          value: false,
        });
      }
      // mobile
      if (state.next.mobile && (state.next.mobile !== state.prev.mobile || firstLoad)) {
        this.setViewPort(true, false);
      }
    },
  },
};
</script>
<style lang="scss">
.bg-footer {
  background: url('https://truelifeorg.s3.amazonaws.com/images/truelife-footerbackground.jpg') no-repeat center bottom;
  height: 450px;
  margin-left: 0px;
  margin-left: -15px;
  margin-right: -15px;
  padding: 15px;
}
.light-theme {
  .bg-js-story-footer {
    background: url('/resources/images/bg_story_footer.jpg') no-repeat center bottom;
    height: 450px;
    margin-left: 0px;
    margin-left: -15px;
    margin-right: -15px;
    padding: 15px;
  }
}

.dark-theme {
  .air__layout__header {
    background-color: #454545;
    border-bottom: solid 1px #ffb612;
    & > div {
      border-bottom: none;
    }
  }
}
</style>
